/* The only moving paint is one masked sheen and three tiny opacity/transform glints. */
(() => {
  if (window.dacArtistFinish) return;
  window.dacArtistFinish = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const connection = navigator.connection;
  const sections = new Map();
  let observer;
  const update = () => sections.forEach((visible, section) => {
    section.toggleAttribute('data-artist-awake', visible && !document.hidden && !motion.matches && !connection?.saveData);
  });
  const collect = root => root.querySelectorAll('.dac-artist-finish').forEach(section => {
    if (sections.has(section)) return;
    sections.set(section, false);
    observer?.observe(section);
  });
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => sections.set(entry.target, entry.isIntersecting));
      update();
    }, { threshold: 0 });
  }
  collect(document);
  document.addEventListener('visibilitychange', update);
  motion.addEventListener('change', update);
  connection?.addEventListener('change', update);
  document.addEventListener('shopify:section:load', event => collect(event.target));
  document.addEventListener('shopify:section:unload', event => {
    sections.forEach((_, section) => {
      if (event.target.contains(section)) {
        observer?.unobserve(section);
        sections.delete(section);
      }
    });
  });
})();
